/**
* 描述：日常考核 接口管理
* 录入人： 王帅
*/
import request from '../request.js'

/**
* 描述：日常考核-分页列表查询
* 接口管理员：俞祥东
* 参数： 
{
    "current":"1",
    "size":"10",
    "markObj":"",//考核类型
    "objName":"",// 考核内容
    "beJudger":"",// 申报人
    "beUnitName":"",// 申报单位
    "uintName":"",// 考核单位
    "startTime":"",// 申报时间
    "endTime":"",
    "status":""// 状态
}
*/
export const getListData = function (data) {
    return request({
        url: 'markRecord/selOpeMarkRecordPageList',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-新增申报-分页列表查询
* 接口管理员：俞祥东
* 参数： 
{
    "current":"1",
    "size":"10",
    "judgeRole":"1013003",//考核人主体类型
    "beJudgeRole":"1014003",//被考核人主体类型
    "markObj":"1015002"// 考核类型
}
*/
export const getSelectData = function (data) {
    return request({
        url: 'markRecord/selProjectApplyPageInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-新增申报-查询评分细项
* 接口管理员：俞祥东
* 参数： 
{
    "judgeRole":"1013003",//考核人主体类型
    "beJudgeRole":"1014003",//被考核人主体类型
    "markObj":"1015002",//考核类型
    "applyBus":"1016001"//适用业务(审计系统码表写死)
}
*/
export const getRulesData = function (data) {
    return request({
        url: 'markRecord/selMarkItemDetailInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-新增或编辑申报
* 接口管理员：俞祥东
* 参数： 

// 新增
{
    "createUserid":"12345600101",//创建人id
    "status":"0",//状态 申报状态 0：待申报 1：已申报 2：已审核
    "busProjectId":"1412666651626835968", // 业务id --selProjectApplyPageInfo接口返回的 busProjectId
    "objName":"工程项目名称", // 工程项目名称
    "markObj":"1015002", //考核类型
    "bejudger":"YUXD", // 申报人
    "beUnitName":"申报单位", // 申报单位
    "unitName":"考核单位", // 申报单位
    "declareTotal":"85", // 申报总分
    "opeRecordDetails": [],//评分标准明细信息
}
*/
export const saveOrUpdate = function (data) {
    return request({
        url: 'markRecord/addOrEditProjectApplyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-查看
* 接口管理员：俞祥东
* 参数： 
{
  "id": "1413068062543482882",
  "judgeRole": "1013002",
  "beJudgeRole": "1013003",
  "markObj": "1015001"
}
*/
export const getApplyInfo = function (data) {
    return request({
        url: 'markRecord/checkProjectApplyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-获取考核单位名称信息
* 接口管理员：俞祥东
* 参数： {}
*/
export const getAssessList = function (data) {
    return request({
        url: 'sysTenant/getAssessCompanyNameList',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-考核打分
* 接口管理员：俞祥东
* 参数： 
{
    "recordId":"1412701758269456385",//考核记录id
    "createUserid":"12345600102",
    "status":"2",
    "versionId":"1412678806786293761",
    "assessTotal":"85",//考核总分
    "limitId":"123412341200001",//主体类型
    "tenantId":"123412341200002",//企业id
    opeRecordDetails: []
}
*/
export const doEvaluate = function (data) {
    return request({
        url: 'markRecord/assessProjectApplyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}

/**
* 描述：日常考核-删除
* 接口管理员：俞祥东
* 参数： 
{
    "id":""//考核记录id
}
*/
export const deleteItem = function (data) {
    return request({
        url: 'markRecord/delProjectApplyInfo',
        method: 'post',
        requestConfig: {
            hideLoading: true
        },
        data
    })
}